// Utility functions for entity types - now using static TYPE_PROFILE enum
import { TYPE_PROFILE } from "./typeProfile";

export const getEntityTypes = async () => {
  // Convert TYPE_PROFILE object to array format
  return Object.values(TYPE_PROFILE).map((profile) => ({
    value: profile.value,
    label: profile.label,
    icon: profile.icon,
    color: profile.color,
  }));
};
